import {
  FETCH_UNITS,
  FETCH_UNITS_SUCCESS,
  FETCH_UNITS_FAILURE,
  CREATE_UNIT,
  CREATE_UNIT_SUCCESS,
  CREATE_UNIT_FAILURE,
} from "./actionTypes";

const initialState = {
  units: [],
  loading: false,
  error: null,
  success: false
};

const unitsReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_UNITS:
      return { ...state, loading: true };
    case FETCH_UNITS_SUCCESS:
      return { ...state, loading: false, units: action.payload.data};
    case FETCH_UNITS_FAILURE:
      return { ...state, loading: false, error: action.payload };
        case CREATE_UNIT:
                  return { ...state, loading: true };
                case CREATE_UNIT_SUCCESS:
                  return {
                    ...state, loading: false, success:true, role: action.payload, error: null };
                case CREATE_UNIT_FAILURE:
                  return { ...state, loading: false, success:false, error: action.payload };
    default:
      return state;
  }
};

export default unitsReducer;
